import RBush from "rbush";
export { cloneRBush };
function cloneRBush(rbush) {
    return (new RBush()).fromJSON(cloneNode(rbush.toJSON()));
}
function cloneNode(node) {
    return {
        children: node.children.map(c => !node.leaf ? cloneNode(c) : c),
        height: node.height,
        leaf: node.leaf,
        minX: node.minX,
        minY: node.minY,
        maxX: node.maxX,
        maxY: node.maxY
    };
}
//# sourceMappingURL=RBushCloner.js.map